import React from 'react';

const MessageItem = ({ message, formatMessageToHtml, toggleDropdown, dropdownOpen, handleCopy, handleEdit }) => {
  return (
    <li
      className={
        message.type === "sent"
          ? "sent-message-group"
          : "media received"
      }
    >
      <ul>
        <li className={`media ${message.type} d-flex align-items-end`}>
          <div className="media-body flex-grow-1">
            <div className="msg-box">
              <div className="position-relative">
                <div className="d-flex align-items-center">
                  {message.type === "sent" ? (
                    <>
                      <div className="chat-actions me-2">
                        <div
                          onClick={() => toggleDropdown(message.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        {dropdownOpen[message.id] && (
                          <ul
                            className="dropdown-menu dropdown-menu-end p-3 show"
                            onMouseLeave={() => toggleDropdown(message.id)}
                          >
                            <li>
                              <a
                                className="dropdown-item reply-btn"
                                onClick={(e) => handleEdit(message.id, e)}
                              >
                                <i className="isax isax-back-square me-2"></i>
                                Chỉnh sửa
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={(e) => handleCopy(message.text, e)}
                              >
                                <i className="isax isax-copy me-2"></i>
                                Sao chép
                              </a>
                            </li>
                          </ul>
                        )}
                      </div>
                      <div className="sent-message">
                        <p className="fs-14">{message.text}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="received-message me-2">
                        <p
                          className="fs-14"
                          dangerouslySetInnerHTML={{ __html: formatMessageToHtml(message.text) }}
                        />
                      </div>
                      <div className="chat-actions me-2">
                        <div
                          onClick={() => toggleDropdown(message.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        {dropdownOpen[message.id] && (
                          <ul
                            className="dropdown-menu dropdown-menu-end p-3 show"
                            onMouseLeave={() => toggleDropdown(message.id)}
                          >
                            <li>
                              <a
                                className="dropdown-item reply-btn"
                                onClick={(e) => handleEdit(message.id, e)}
                              >
                                <i className="isax isax-back-square me-2"></i>
                                Chỉnh sửa
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                onClick={(e) => handleCopy(message.text, e)}
                              >
                                <i className="isax isax-copy me-2"></i>
                                Sao chép
                              </a>
                            </li>
                          </ul>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {message.type === "sent" && (
                <div className="d-flex align-items-center justify-content-end mb-1">
                  <div>
                    <div className="d-flex justify-content-end">
                      <p className="fs-12">
                        {message.timestamp}{" "}
                        <i className="ms-1 text-success fa-solid fa-check-double"></i>
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </li>
      </ul>
    </li>
  );
};

export default MessageItem;